/* Version 2 home sections: product showcase tabs + "Buy Now" quick add (snippets/jh-product-card.liquid). */
(() => {
  if (window.jhHomeInit) return;
  window.jhHomeInit = true;

  // Tabs: <div data-jh-tabs> with [role=tab][aria-controls] buttons and matching [role=tabpanel]
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-jh-tabs] [role="tab"]');
    if (!tab) return;
    const root = tab.closest('[data-jh-tabs]');
    root.querySelectorAll('[role="tab"]').forEach((t) => t.setAttribute('aria-selected', t === tab ? 'true' : 'false'));
    root.querySelectorAll('[role="tabpanel"]').forEach((p) => { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
  });

  // Quick add: same section refresh as the theme's ProductCard (assets/app.min.js), then open the cart drawer
  const sectionsToRender = [
    { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.float_count' }
  ];
  const innerHTML = (html, selector) => {
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : '';
  };

  document.addEventListener('click', (e) => {
    const button = e.target.closest('[data-jh-add]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    const label = button.textContent;
    button.setAttribute('aria-busy', 'true');
    button.textContent = (window.theme && theme.strings && theme.strings.addingToCart) || 'Adding…';

    const body = new FormData();
    body.append('id', button.dataset.jhAdd);
    body.append('quantity', 1);
    body.append('sections', sectionsToRender.map((s) => s.section));
    body.append('sections_url', window.location.pathname);

    const addUrl = (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add';
    fetch(addUrl, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body })
      .then((r) => r.json())
      .then((res) => {
        if (res.status) {
          button.textContent = res.description || res.message || 'Could not add';
          setTimeout(() => { button.textContent = label; }, 2500);
          return;
        }
        const drawer = document.getElementById('Cart-Drawer');
        if (!drawer || !res.sections) {
          window.location.href = (window.theme && theme.routes && theme.routes.cart_url) || '/cart';
          return;
        }
        sectionsToRender.forEach((s) => {
          const host = document.getElementById(s.id);
          if (!host || !res.sections[s.section]) return;
          (host.querySelector(s.selector) || host).innerHTML = innerHTML(res.sections[s.section], s.selector);
        });
        if (typeof CartDrawer !== 'undefined') new CartDrawer();
        if (typeof dispatchCustomEvent === 'function') dispatchCustomEvent('cart:item-added', { product: res });
        button.textContent = label;
        setTimeout(() => {
          document.getElementById('cart-drawer-toggle').click();
          if (typeof dispatchCustomEvent === 'function') dispatchCustomEvent('cart-drawer:open');
        }, 100);
      })
      .catch((err) => {
        console.error(err);
        button.textContent = label;
      })
      .finally(() => button.removeAttribute('aria-busy'));
  });
})();
